import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Branches from "@/components/site/Branches";
import Officers from "@/components/site/Officers";
import MissCrownJewels from "@/components/site/MissCrownJewels";
import Events from "@/components/site/Events";
import Gallery from "@/components/site/Gallery";
import JoinForm from "@/components/site/JoinForm";
import ContactSection from "@/components/site/ContactSection";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main
      className="min-h-screen bg-[#050505] text-white overflow-x-hidden"
      data-testid="home-page"
    >
      <Navbar />
      <Hero />
      <About />
      <Branches />
      <Officers />
      <MissCrownJewels />
      <Events />
      <Gallery />
      <JoinForm />
      <ContactSection />
      <Footer />
    </main>
  );
}
